import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';

@Component({
  selector: 'sample-questions-pre',
  templateUrl: './sample-questions-pre.component.html',
  styleUrls: ['./sample-questions-pre.component.scss']
})
export class SampleQuestionsPreComponent implements OnInit {

  public selectedLanguage = new FormControl();
  public breadcrumb = [];

  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.breadcrumb = [
      this.breadcrumbsService.APPLICANT_LANDING(),
      this.breadcrumbsService._CURRENT(this.lang.tra('title_sample_questions'), this.router.url),
    ];
    this.selectedLanguage.setValue(this.lang.getCurrentLanguage() || 'en');
  }

}
